// biome-ignore lint/style/noRestrictedImports: legacy import kept for compatibility
import { Container } from '@crehana/ui';
import dynamic from 'next/dynamic';

import CourseListSkeleton from './components/course-list-skeleton';

export const LazyMyCoursesWithFilters = dynamic(
  () =>
    import(
      /* webpackChunkName: "user-dashboard-my-courses-filters" */ './my-courses-with-filters'
    ),
  {
    loading: () => (
      <Container type="dashboard">
        <CourseListSkeleton />
      </Container>
    ),
    ssr: false,
  },
);
